if (!customElements.get("onetime-and-subscription")) {
  customElements.define(
    "onetime-and-subscription",
    class OneTimeAndSubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        this.form = document.querySelector('form.form[action="/cart/add"]');
        this.handleBoxClick = this.handleBoxClick.bind(this);

        this.boxes = this.querySelectorAll('.onetime-and-subscription__box');
        this.boxes.forEach(elem => elem.addEventListener('click', this.handleBoxClick));
        this.setSellingPlan(this.querySelector('input[type="radio"]:checked'));
      }

      setSellingPlan(radioButton) {
        if (!this.form.querySelector('input[type="hidden"][name="selling_plan"]')) {
          const input = document.createElement('input');
          input.type='hidden';
          input.name='selling_plan';
          this.form.appendChild(input);
        }
        this.form.querySelector('input[type="hidden"][name="selling_plan"]').value = radioButton.dataset.sellingPlanId || "";
      }

      renderBoxes(currentBox) {
        this.boxes.forEach(box => box.classList.remove('active'));
        currentBox.classList.add('active');
      }

      getBoxNode(target) {
        if (target.classList.contains('onetime-and-subscription__box')) {
          return target;
        }
        return target.closest('.onetime-and-subscription__box');
      }
      handleBoxClick(ev) {
        const currentBox = this.getBoxNode(ev.target);
        const radioBtn = currentBox.querySelector('input[type="radio"]');
        radioBtn.checked = true;
        this.renderBoxes(currentBox);
        this.setSellingPlan(radioBtn);
      }
    }
  );
}
